<template>
	<div>
		<short-header />
		<div class="panel mt-4">
			<div class="container">
				<div class="row d-flex justify-content-center align-items-center flex-column">
					<div class="col-12 col-md-10 col-lg-10">
						<div v-if="page.image_url" class="embed-responsive embed-responsive-21by9 image mb-4">
							<b-img-lazy class="embed-responsive-item" fluid-grow :src="page.image_url" />
						</div>

						<div class="title mb-3">
							{{ page.name }}
						</div>

						<div v-if="page.description" class="mb-3" v-html="page.description" />

						<FormulateForm
							v-if="autocompleted"
							v-model="userValues"
							:schema="page.formScenario.formulateForm.schema_frontend"
							class="row"
							@submit="submit"
						>
							<div v-if="page.formScenario.id === 305 || page.formScenario.id === 415" class="col-12 order-0 mb-4">
								<div class="mb-4">
									<button
										type="button"
										class="btn btn-outline-primary mr-2"
										@click="userValues.amount = 1000"
									>
										1000 ₽
									</button>

									<button
										type="button"
										class="btn btn-outline-primary mr-2"
										@click="userValues.amount = 3000"
									>
										3 000 ₽
									</button>

									<button
										type="button"
										class="btn btn-outline-primary mr-2"
										@click="userValues.amount = 5000"
									>
										5 000 ₽
									</button>

									<button
										type="button"
										class="btn btn-outline-primary mr-2"
										@click="userValues.amount = 10000"
									>
										10 000 ₽
									</button>
								</div>

								<FormulateInput
									v-model="userValues.amount"
									name="amount"
									label="Другая сумма поддержки"
									placeholder="Введите значение в рублях"
									type="number"
									validation="bail|required|max:1000000|number"
									:validation-messages="{
										required: 'Введите значение в рублях',
										max: 'Максимальное допустимое значение - 1 млн. руб.',
									}"
								/>
							</div>

							<div v-else class="col-12 order-0 mb-4">
								<div class="mb-4 donation">

									<!-- <button
										type="button"
										class="btn btn-outline-primary mr-2 mb-2"
										@click="userValues.amount = 5000"
									>
										5 000 ₽
									</button> -->

									<button
										type="button"
										class="btn btn-outline-primary mr-2 mb-2"
										@click="userValues.amount = 10000"
									>
										10 000 ₽
									</button>


									<button
										type="button"
										class="btn btn-outline-primary mr-2 mb-2"
										@click="userValues.amount = 50000"
									>
										50 000 ₽
									</button>

									<button
										type="button"
										class="btn btn-outline-primary mr-2 mb-2"
										@click="userValues.amount = 100000"
									>
										100 000 ₽
									</button>

									<!-- <button
										type="button"
										class="btn btn-outline-primary mr-2 mb-2"
										@click="userValues.amount = 200000"
									>
										200 000 ₽
									</button> -->


								</div>

								<FormulateInput
									v-model="userValues.amount"
									name="amount"
									label="Другая сумма поддержки"
									placeholder="Введите значение в рублях"
									type="number"
									validation="bail|required|max:1000000|number"
									:validation-messages="{
										required: 'Введите значение в рублях',
										max: 'Максимальное допустимая сумма - 1 млн. рублей',
									}"
								/>
							</div>

							<div class="col-12 order-2">
								<div class="row">
									<div class="col-12">
										<agreement-input class="mb-2" />
										<!-- <loyalty-registration-input class="mb-2" /> -->
										<donation-agreement-input :href="page.agreements" />
										<advertising-mailings-input class="mb-4" />

										<FormulateInput
											type="submit"
											class="mt-3"
											:disabled="isSubmitLoading"
										>
											<b-spinner
												v-if="isSubmitLoading"
												style="margin-right: 15px; width: 1.3em; height: 1.3em;"
											/>
											{{ isSubmitLoading ? 'Идет отправка...' : 'Отправить' }}
										</FormulateInput>
									</div>
								</div>
							</div>
						</FormulateForm>

						<div v-else>
							<h5 class="mb-3">
								Форма загружается
							</h5>
							<div>
								<b-spinner size="sm" />
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<main-footer />
	</div>
</template>

<script>
import AgreementInput from '~/components/panels/formulate/products/components/AgreementInput.vue';
import DonationAgreementInput from '~/components/panels/formulate/products/components/DonationAgreementInput.vue';
import AdvertisingMailingsInput from '~/components/panels/formulate/products/components/AdvertisingMailingsInput.vue';
import autocompletesFormulateForm from '~/mixins/autocompletesFormulateForm';
import receivesFieldsFromFormulateSchema from '~/mixins/receivesFieldsFromFormulateSchema';
import '~/utils/vue-formulate';
import ShortHeader from '~/components/layouts/headers/ShortHeader.vue';
import MainFooter from '~/components/layouts/footers/MainFooter.vue';
import withAnalytics from '~/mixins/withAnalytics';
import LoyaltyRegistrationInput from '~/components/panels/formulate/products/components/LoyaltyRegistrationInput.vue';
import agreementsMixin from '~/mixins/agreementsMixin';

export default {
	name: 'DonationPage',
	components: {
		LoyaltyRegistrationInput,
		MainFooter,
		ShortHeader,
		AgreementInput,
		DonationAgreementInput,
		AdvertisingMailingsInput,
	},
	mixins: [
		autocompletesFormulateForm,
		receivesFieldsFromFormulateSchema,
		withAnalytics,
		agreementsMixin,
	],
	async asyncData({ app, params }) {
		const { $api } = app;
		const { hash } = params;

		const { data: page } = await $api.getDonationPage(hash);

		return {
			page,
			hash,
		};
	},
	data() {
		return {
			page: null,
			userValues: {},
			isSubmitLoading: false,
			hash: '',
		};
	},
	watch: {
		'$auth.user': {
			handler(user) {
				if (user && this.page) {
					this.getAutocompletedFields(
						this.receiveFieldsFromSchema(
							this.page.formScenario.formulateForm.schema_frontend,
						),
					).then((res) => {
						this.userValues = { ...this.userValues, ...res };
					});
				}
			},
		},
		page: {
			handler(page) {
				if (page) {
					this.getAutocompletedFields(
						this.receiveFieldsFromSchema(
							page.formScenario.formulateForm.schema_frontend,
						),
					).then((res) => {
						this.userValues = { ...this.userValues, ...res };
					});
				}
			},
			deep: true,
			immediate: true,
		},
	},
	methods: {
		async submit() {
			this.isSubmitLoading = true;

			const formScenarioId = this.page.formScenario.id;

			if (!this.agreements.marketing_emails) {
				this.agreements.marketing_emails = !!this.userValues.advertisingMailingsAgreement;
			}
			if (!this.agreements.personal_data) {
				this.agreements.personal_data = !!this.userValues.personalData;
			}
			this.setAgreementFields();

			await this.$api
				.submitFormulateForm(
					formScenarioId,
					{
						user_data: {
							sklTargetAction: 'Пожертвование',
							sklAgreeSubscribeLookup: this.agreements.marketing_emails ? 'да' : 'нет',
							donation_hash: this.hash,
							...this.userValues,
							...this.getAnalyticsData(),
						},
					},
				)
				.then((response) => {
					window.location = response.url;

					this.isSubmitLoading = false;
				})
				.catch(() => {
					this.isSubmitLoading = false;
				});
		},
	},
};
</script>

<style scoped lang="scss">
@import "~/assets/styles/sk_variables";
@import "~/assets/styles/bootstrap/scss/functions";
@import "~/assets/styles/bootstrap/scss/variables";
@import "~/assets/styles/bootstrap/scss/mixins";
@import "~/assets/styles/components/home/panel-programms";

.formulate-input {
	.formulate-input-label {
		margin-bottom: 1rem !important;
	}
}

.b-1 {
	border: 0px solid $border-color;
	padding: 0rem;
	@include media-breakpoint-up(md) {
		border: 1px solid $border-color;
		padding: 3rem;
	}
}

.image {
	width: 100%;
	height: 100%;
	overflow: hidden;
	flex: none;
	order: 0;
	flex-grow: 0;
	img {
		height: 100% !important;
		object-fit: cover;
	}
}

.donation {
	.btn {
		@include media-breakpoint-down(md) {
			font-size: 0.8rem;
		}
	}
}

</style>
